import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    labelDefault: String,
    labelLoading: String,
    labelSuccess: String,
    labelError: String
  }

  static targets = ["button"]

  async translate(event) {
    event.preventDefault()
    const button = this.buttonTarget

    button.disabled = true
    button.textContent = this.labelLoadingValue

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken,
          'Accept': 'application/json'
        }
      })

      if (!response.ok) {
        throw new Error('Translation failed')
      }

      const data = await response.json()
      this.fillForm(data)

      button.textContent = this.labelSuccessValue
      setTimeout(() => { button.textContent = this.labelDefaultValue }, 3000)
    } catch (error) {
      console.error('Translation error:', error)
      button.textContent = this.labelErrorValue
      setTimeout(() => { button.textContent = this.labelDefaultValue }, 3000)
    } finally {
      button.disabled = false
    }
  }

  fillForm(data) {
    const nameInput = document.getElementById('question_name')
    if (nameInput && data.name) {
      nameInput.value = data.name
    }

    const explanationInput = document.getElementById('question_explanation')
    if (explanationInput && data.explanation) {
      explanationInput.value = data.explanation
    }

    // Rails fields_for renders the hidden [id] input as a sibling BEFORE the .nested-fields div,
    // so we extract the index from the name attribute and query the [name] input by index directly.
    if (data.answers) {
      const idInputs = document.querySelectorAll('input[name*="answers_attributes"][name$="[id]"]')

      data.answers.forEach(answer => {
        idInputs.forEach(idInput => {
          if (String(idInput.value) === String(answer.id)) {
            const match = idInput.name.match(/answers_attributes\]\[(\d+)\]\[id\]/)
            if (match) {
              const index = match[1]
              const nameInput = document.querySelector(`input[name="question[answers_attributes][${index}][name]"]`)
              if (nameInput && answer.name) {
                nameInput.value = answer.name
              }
            }
          }
        })
      })
    }
  }

  get csrfToken() {
    return document.querySelector("[name='csrf-token']")?.content || ''
  }
}
